import React, { memo, useEffect } from "react"
import Error from "../components/svg/Error"
import LinkButtonRed from "../components/buttons/linkButtonRed/linkButtonRed"
import Header from "../components/header/header"
import Footer from "../components/newComponents/footer/footer"
import { useHomeNewMetadata } from "../queries/useHomeNewMetaData"

const Errorpage = () => {
  const homeData = useHomeNewMetadata()

  useEffect(() => {
    localStorage.removeItem("casepage")
    localStorage.removeItem("blogpage")
  }, [])

  return (
    <>
      <Header headerClass="casestudy red-header" homeData={homeData?.wp} />
      <div className="error-page">
        <div className="error-wrap">
          <Error />
          <LinkButtonRed linkTo="/" btnText="Home" />
        </div>
      </div>
      <Footer
        footerMenu={homeData?.wpMenu?.menuItems}
        homeData={homeData?.wp?.myThemeOptionsSettings}
      />
    </>
  )
}
export default memo(Errorpage)
